import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";

import reducer from "./reducer";

// sagas
import getHomePageWidgetSaga from './saga/getHomePageWidgetSaga'
import getAppointmentDetailSaga from './saga/getAppointmentDetailSaga'
import getAppointmentSearchSaga from './saga/getAppointmentSearchSaga'
import getPatientListSaga from './saga/getPatientListSaga'
import updatePatientDetailSaga from './saga/updatePatientDetailSaga'
import getAppointmentListSaga from './saga/getAppointmentListSaga'
import deletePatientListSaga from './saga/deletePatientListSaga'
import getPatientDetailSaga from './saga/getPatientDetailSaga'
import getCouponListSaga from './saga/getCouponListSaga'
import deleteCouponSaga from './saga/deleteCouponSaga'
import saveCouponSaga from './saga/saveCouponSaga'
import getCouponDetailSaga from './saga/getCouponDetailSaga'
import saveArticleLikeSaga from './saga/saveArticleLikeSaga'
import saveScheduleTimingSaga from './saga/saveScheduleTimingSaga'
import getScheduleTimingListSaga from './saga/getScheduleTimingListSaga'
import getAllScheduleTimingListSaga from './saga/getAllScheduleTimingListSaga'
import saveScheduleTimingCustomizeSaga from './saga/saveScheduleTimingCustomizeSaga'
import deleteScheduleTimeSlotSaga from './saga/deleteScheduleTimeSlotSaga'
import getScheduleTimingSagaList from './saga/getScheduleTimingListSaga'
import saveAppointmentSaga from './saga/saveAppointmentSaga'
import getPatientDropdownListSaga from './saga/getPatientDropdownListSaga'
import loginSaga from './saga/loginSaga'
import getDoctorDetailSaga from './saga/getDoctorDetailSaga'
import getPatientAppointmentListSaga from './saga/getPatientAppointmentListSaga'
import savePatientIntakeFormSaga from './saga/savePatientIntakeFormSaga'
import getPageContentDetailSaga from './saga/getPageContentDetailSaga'
import getPatientDetailForIntakeFormSaga from './saga/getPatientDetailForIntakeFormSaga'
import saveAppointmentReportSaga from './saga/saveAppointmentReportSaga'
import updateDoctorDetailSaga from './saga/updateDoctorDetailSaga'
import resetPasswordSaga from './saga/resetPasswordSaga'
import getListTestMasterSaga from './saga/getListTestMasterSaga'
import getInstituteListSaga from './saga/getInstituteListSaga'
import getContainerListSaga from './saga/getContainerListSaga'
import saveEmergencyDtrfSaga from './saga/saveEmergencyDtrfSaga'
import getEmergencyDtrfListSaga from './saga/getEmergencyDtrfListSaga'
import getCommonMasterListSaga from './saga/getCommonMasterListSaga'
import saveAppointmentCompleteStatusSaga from './saga/saveAppointmentCompleteStatusSaga'
import saveAppointmentNotAttendedStatusSaga from './saga/saveAppointmentNotAttendedStatusSaga'
import getArticleListSaga from './saga/getArticleListSaga'
import getArticleHomeListSaga from './saga/getArticleHomeListSaga'
import getArticleBySlugSaga from './saga/getArticleBySlugSaga'
import saveDoctorSaga from './saga/saveDoctorSaga'
import sendOtpForForgotPasswordSaga from './saga/sendOtpForForgotPasswordSaga'
import resetForgotPasswordSaga from './saga/resetForgotPasswordSaga'
import getDtrfReportListSaga from './saga/getDtrfReportListSaga'
import getTestBookListSaga from './saga/getTestBookListSaga'
import getBookmarkArticlesSaga from './saga/getBookmarkArticlesSaga'
import saveArticleBookmarkSaga from './saga/saveArticleBookmarkSaga'
import getTestimonialSaga from './saga/getTestimonialSaga'
import getViewConultationSaga from './saga/getViewConultationSaga'
import getQuickSupportSaga from './saga/getQuickSupportSaga'
import bookedAppointmentActivitySaga from "./saga/bookedAppointmentActivitySaga"
import sendSignUpRequestSaga from "./saga/sendSgnUpRequestSaga"
import cancelAppointmentSaga from "./saga/cancelAppointmentSaga"
import getTestCategoriesSaga from "./saga/getTestCategoriesSaga"
import getTokenDetailsSaga from "./saga/getTokenDetailsSaga"
import getArticleTagsSaga from "./saga/getArticleTagsSaga"
// create the saga middleware
const sagaMiddleware = createSagaMiddleware();
// mount it on the Store
const store = createStore(
  reducer,
  composeWithDevTools(applyMiddleware(sagaMiddleware))
);

// then run the saga
sagaMiddleware.run(getHomePageWidgetSaga);
sagaMiddleware.run(getAppointmentDetailSaga);
sagaMiddleware.run(getAppointmentSearchSaga);
sagaMiddleware.run(getPatientDropdownListSaga);
sagaMiddleware.run(getAppointmentListSaga);
sagaMiddleware.run(getPatientListSaga);
sagaMiddleware.run(updatePatientDetailSaga);
sagaMiddleware.run(deletePatientListSaga);
sagaMiddleware.run(getPatientDetailSaga);
// sagaMiddleware.run(updatePatientListSaga)
sagaMiddleware.run(getCouponListSaga);
sagaMiddleware.run(deleteCouponSaga);
sagaMiddleware.run(saveCouponSaga);
sagaMiddleware.run(getCouponDetailSaga);
// sagaMiddleware.run(updatePatientSaga)
sagaMiddleware.run(deletePatientListSaga)
sagaMiddleware.run(getPatientDetailSaga)
sagaMiddleware.run(saveScheduleTimingCustomizeSaga)
sagaMiddleware.run(saveScheduleTimingSaga)
sagaMiddleware.run(getScheduleTimingListSaga)
sagaMiddleware.run(getAllScheduleTimingListSaga)
sagaMiddleware.run(deleteScheduleTimeSlotSaga)
sagaMiddleware.run(getScheduleTimingSagaList)
sagaMiddleware.run(saveAppointmentSaga)
sagaMiddleware.run(loginSaga)
sagaMiddleware.run(getDoctorDetailSaga)
sagaMiddleware.run(updateDoctorDetailSaga)
sagaMiddleware.run(resetPasswordSaga)
sagaMiddleware.run(saveArticleLikeSaga)
sagaMiddleware.run(getPatientAppointmentListSaga)
sagaMiddleware.run(savePatientIntakeFormSaga)
sagaMiddleware.run(getPageContentDetailSaga)
sagaMiddleware.run(getPatientDetailForIntakeFormSaga)
sagaMiddleware.run(saveAppointmentReportSaga)
sagaMiddleware.run(getListTestMasterSaga)
sagaMiddleware.run(getInstituteListSaga)
sagaMiddleware.run(getContainerListSaga)
sagaMiddleware.run(saveEmergencyDtrfSaga)
sagaMiddleware.run(getEmergencyDtrfListSaga)
sagaMiddleware.run(getCommonMasterListSaga)
sagaMiddleware.run(saveAppointmentCompleteStatusSaga)
sagaMiddleware.run(saveAppointmentNotAttendedStatusSaga)
sagaMiddleware.run(getArticleListSaga)
sagaMiddleware.run(getArticleHomeListSaga)
sagaMiddleware.run(getArticleBySlugSaga)
sagaMiddleware.run(saveDoctorSaga)
sagaMiddleware.run(sendOtpForForgotPasswordSaga)
sagaMiddleware.run(resetForgotPasswordSaga)
sagaMiddleware.run(getDtrfReportListSaga)
sagaMiddleware.run(getTestBookListSaga)
sagaMiddleware.run(getBookmarkArticlesSaga)
sagaMiddleware.run(saveArticleBookmarkSaga)
sagaMiddleware.run(getTestimonialSaga)
sagaMiddleware.run(getViewConultationSaga)
sagaMiddleware.run(getQuickSupportSaga)
sagaMiddleware.run(bookedAppointmentActivitySaga)
sagaMiddleware.run(sendSignUpRequestSaga)
sagaMiddleware.run(cancelAppointmentSaga)
sagaMiddleware.run(getTestCategoriesSaga)
sagaMiddleware.run(getTokenDetailsSaga)
sagaMiddleware.run(getArticleTagsSaga);
// render the application
export default store;
